import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AlertService, AlertInfo, AlertType } from '../Alert/alert.service';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root',
})
export class FloorService extends BaseService {
  constructor(
    private http: HttpClient,
    alertService: AlertService
  ) {
    super('floor', alertService);
  }

  getFloor(id: number): Observable<any> {
    const url = `${this.url}/${id}`;
    return this.http.get(url).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting Floor', err))
    );
  }

  create(body: any): Observable<any> {
    const url = `${this.url}/`;
    return this.http.post(url, body).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Creating Floor', err))
    );
  }

  update(id: number, body: any): Observable<any> {
    const url = `${this.url}/${id}`;
    return this.http.patch(url, body).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error updating floor', err))
    );
  }

  delete(id: number): Observable<any> {
    const url = `${this.url}/${id}`;
    return this.http.delete(url).pipe(
      map((response) => response),
      catchError((err) => this.handleError('Error deleting floor', err))
    );
  }

  getDivisions(): Observable<any> {
    const url = this.url + '/divisions';
    return this.http.get(url).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting Divisions', err))
    );
  }

  getMyDivisions(): Observable<any> {
    const url = this.url + '/mydivisions';
    return this.http.get(url).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting Divisions', err))
    );
  }

  getWorkstations(id: number, excludeClosures = false): Observable<any> {
    const url = this.url + '/' + id + '/workstations';
    var params = new HttpParams();
    params = params.set('excludeClosures', excludeClosures.toString());
    return this.http.get(url, { params: params }).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting Workstations', err))
    );
  }

  getPagedWorkstations(
    id: number,
    pageNumber: number,
    pageSize: number,
    sortOrder = 'asc',
    sortColumn = '',
    workstationNumber = ''
  ): Observable<any> {
    const url = this.url + '/' + id + '/workstations';

    var params = new HttpParams();
    params = params.set('pageNumber', pageNumber.toString());
    params = params.set('pageSize', pageSize.toString());

    if (sortOrder) params = params.set('sortOrder', sortOrder.toString());

    if (sortColumn) params = params.set('sortColumn', sortColumn.toString());

    if (workstationNumber) params = params.set('workstationNumber', workstationNumber.toString());

    return this.http.get(url, { params: params }).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Getting Workstations', err))
    );
  }

  disable(schedule: any): Observable<any> {
    const url = this.url + '/disable';
    return this.http.post(url, schedule).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Disabling Building', err))
    );
  }

  enable(id: number): Observable<any> {
    const url = this.url + '/enable/' + id;
    return this.http.post(url, null).pipe(
      map((data) => data),
      catchError((err) => this.handleError('Error Enabling Building', err))
    );
  }
}
